export default "__VITE_ASSET__COdmkxtE__"